import React from 'react'
import PropTypes  from 'prop-types'
export default function Projects(props) {
    return (
        <div className={`container text-center pdown text-${props.mode==='light'?'black':'white'}`}>

            <h1 className='my-4'>Projects</h1>
            <div className="row">
                <div className="col-sm">
                <div className={`card pc ${props.mode==='light'?'bgw':'bgb'} text-${props.mode==='light'?'black':'white'}`} >
                <div className="dflex justify-content-center">
                    <img src="spotify.png" className="card-img-top sp" alt=""/>
                </div>
                <div className="card-body">
                <h5 className="card-title">Spotify Prototype</h5>
                <p className="card-text">A Pure prototype of Spotify which playes music add musics and works like orignal.</p>
                <a href="/" className={`btn btn-${props.mode==='light'?'dark':'light'}`}>Check it Out</a>
            </div>
            </div>
                </div>

                <div className="col-sm">
                    
            <div className={`card pc ${props.mode==='light'?'bgw':'bgb'} text-${props.mode==='light'?'black':'white'}`} >
                <img src="Meta.jpg" className="card-img-top" alt="" height={"300px"}/>
                <div className="card-body">
                <h5 className="card-title">Metaverse</h5>
                <p className="card-text">Some quick work on metaverse field,</p>
                <a href="/" className={`btn btn-${props.mode==='light'?'dark':'light'}`}>Check it Out</a>
            </div>
            </div>

                </div>

                <div className="col-sm">
                    
                    <div className={`card pc ${props.mode==='light'?'bgw':'bgb'} text-${props.mode==='light'?'black':'white'}`} >
                        <img src="NT.jpg" className="card-img-top" alt="" height={"300px"}/>
                        <div className="card-body">
                        <h5 className="card-title">Netflix Prototype</h5>
                        <p className="card-text">Created Netflix Prototype using components base</p>
                        <a href="/" className={`btn btn-${props.mode==='light'?'dark':'light'}`}>Check it out</a>
                    </div>
                    </div>
        
                        </div>
            </div>

        </div>
    )
}
